import { initAxiosRH, loadAbort } from "#api/axios.service"
const axios=initAxiosRH()

const VACANCY="talent_cloud/vacancy"
const AUTHORIZATION=(id)=> `${VACANCY}/${id}/authorization`
const HISTORY=(id)=> `${VACANCY}/${id}/history`


export const vacancyGet = (params) => {
    const controller= loadAbort()
    const call= axios.get(VACANCY,{params,signal:controller.signal})
    return {call,controller}
}
export const vacancyPost = (data,params) => {
    const controller= loadAbort()
    const call= axios.post(VACANCY,data,{params,signal:controller.signal})
    return {call,controller}
}
export const vacancyIdPut = (id,data,params) => {
    const controller= loadAbort()
    const call= axios.put(`${VACANCY}/${id}`,data,{params,signal:controller.signal})
    return {call,controller}
}

export const vacancyAuthGet = ({id,params}) => {
    const controller= loadAbort()
    const call= axios.get(AUTHORIZATION(id),{params,signal:controller.signal})
    return {call,controller}
}
export const vacancyHistoryGet = ({id,params}) => {
    const controller= loadAbort()
    const call= axios.get(HISTORY(id),{params,signal:controller.signal})
    return {call,controller}
}
export const vacancyAuthIdPut = (vacanteId,id,data,params) => {
    const controller= loadAbort()
    const call= axios.put(`${AUTHORIZATION(vacanteId)}/${id}`,data,{params,signal:controller.signal})
    return {call,controller}
}

export const vacantesGet = (params) => {
    const controller= loadAbort()
    const call= axios.get(VACANCY,{params,signal:controller.signal})
    return {call,controller}
}

export const vacanteGet = (vacanteId) => {
    const controller= loadAbort()
    const call= axios.get(`${VACANCY}/${vacanteId}`,{signal:controller.signal})
    return {call,controller}
}

